export default __webpack_public_path__ + "static/media/salesforce.a9991c83.png";